<div class="title-container">
  <p class="subtitle">{{ subtitle() | uppercase }}</p>
</div>
